import React from 'react'

const PrimaryPhysician = () => {
  return (
    <div className=" bg-white relative flex flex-col max-w-md ">
    <p className="text-body-md text-left bg-gray-20 p-6 text-teal-300 font-semibold ">
      {" "}
      Minor Ailments: What happens if a Patient does not have a
      Primary Provider?
    </p>
    <div className="flex flex-col bg-white p-6 gap-4 ">
      <p className="text-body-sm text-left text-teal-300">
        The regulations require a pharmacist to notify "the
        patient's primary care provider (if any) within a
        reasonable time" that they prescribed a drug for the
        patient.
      </p>
      <p className="text-body-sm text-left text-teal-300">
        If there is NO Primary Care Provider or Physician to notify
        at this time, this information is retained on the patient
        record in accordance with legislation and must continue to
        be accessible to the patient and their circle of care.
      </p>
      <p className="text-body-sm text-left text-teal-300">
        As the Prescriber, the Pharmacist is responsible for
        monitoring and follow-up on the treatment plan and
        prescribed therapy, essentially assuming the role of
        Primary Care Provider or Physician until the patient's care
        can be transitioned, if necessary, to another healthcare
        professional.
      </p>
      <p className="text-body-sm text-left text-teal-300">
        More information <b><a href='https://www.ocpinfo.com/practice-education/practice-tools/faqs/minor-ailment-faqs/'>here.</a></b>
      </p>
    </div>
  </div>
  )
}

export default PrimaryPhysician